import { CheckCircle2 } from "lucide-react";
import { PRICING_URL } from "@/lib/marketing";

export const IncludedBadge = ({ testid = "included-badge" }) => (
  <a href={PRICING_URL} data-testid={testid}
     className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.16em] font-semibold text-[#275C3F] bg-[#EAF0EA] border border-[#275C3F]/20 px-3 py-1.5 rounded-sm hover:bg-[#DDE8DE] transition-colors duration-200">
    <CheckCircle2 className="h-3.5 w-3.5" /> Included in Pro and Vision
  </a>
);
